import React from "react";
import { LandingPageType } from "../MobileLandingPage";

export const getFallbackTitle = (type: LandingPageType): React.ReactNode => {
  const typeLabel = (() => {
    switch (type) {
      case LandingPageType.FLIGHTS:
        return "flights";
      case LandingPageType.HOTELS:
        return "hotels";
      case LandingPageType.STAYS:
      case LandingPageType.PREMIUM_STAYS:
        return "vacation rentals";
      case LandingPageType.CARS:
        return "rental cars";
      case LandingPageType.PACKAGES:
        return "packages";
      case LandingPageType.EXPERIENCES:
        return "activities";
      default:
        return "travel options";
    }
  })();

  return (
    <>
      Thousands of <strong>{typeLabel}</strong> to choose from.
    </>
  );
};

export const PARADISE_TITLE = "Your next journey starts here.";

export const EARN_ENHANCEMENT_TITLE = (
  primaryEarnRate: string | number,
  productDisplayName: string,
  currency: string,
  type: LandingPageType,
  secondaryEarnRate?: string | number
) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  const currencyDescription = currency.includes("cash")
    ? "cash back"
    : currency;
  if (
    primaryEarnRate &&
    secondaryEarnRate &&
    (type === LandingPageType.STAYS || type === LandingPageType.HOTELS)
  ) {
    if (primaryEarnRate === secondaryEarnRate) {
      return (
        <span className="font-regular">
          Earn{" "}
          <strong>
            {primaryEarnRate}
            {multiplier} {currencyDescription} on stays
          </strong>{" "}
          with {productDisplayName}.
        </span>
      );
    }

    return (
      <span className="font-regular">
        Earn{" "}
        <strong>
          {primaryEarnRate}
          {multiplier} {currencyDescription} on hotels
        </strong>{" "}
        and{" "}
        <strong>
          {secondaryEarnRate}
          {multiplier} {currencyDescription} on vacation rentals{" "}
        </strong>
        with {productDisplayName}.
      </span>
    );
  }
  return (
    <span className="font-regular">
      Earn{" "}
      <strong>
        {primaryEarnRate}
        {multiplier} {currencyDescription}{" "}
      </strong>{" "}
      on {type} with your {productDisplayName} account.
    </span>
  );
};

export const SUBTITLE =
  "Book with flexibility and enjoy elevated travel benefits.";
export const STAYS_SUBTITLE =
  "Choose from hundreds of thousands of properties around the world.";
